import type { Project } from '../models/session'
import type { ProjectDto } from '../../data/dto/session.dto.ts'

export const mapProjectDtoToProject = (dto: ProjectDto): Project => ({
  id: dto.projectId,
  name: dto.projectName,
})
